import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NavService } from '../../_services/_nav.service';
import { CuestionarioPregunta } from '../../_models/cuestionario-pregunta';
import { CuestionarioPreguntaService } from '../../_services/cuestionario-pregunta.service';
import { Cuestionario } from '../../_models/cuestionario';
import { CuestionarioPreguntaRespuesta } from '../../_models/cuestionario-pregunta-respuesta';
import { forkJoin } from 'rxjs';
import { CuestionarioPreguntaRespuestaService } from '../../_services/cuestionario-pregunta-respuesta.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { CuestionarioService } from '../../_services/cuestionario.service';
import { Funcionalidad } from '../../_models/funcionalidad';
import { RetornoFuncionalidades } from '../../_models/retorno-funcionalidades';
import { ActivatedRoute, Params, Route, Router } from '@angular/router';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MenuVisitaService } from '../../_services/menu-visita.service';
import { ListaService } from '../../_services/lista.service';
import { ListaItem } from '../../_models/lista-item';
import { MenuVisita } from '../../_models/menu-visita';
import { MenuVisitaVinculacionService } from '../../_services/menu-visita-vinculacion.service';
import { MenuVisitaVinculacion } from '../../_models/menu-visita-vinculacion';

@Component( {
  selector: 'app-vinculacion-tercero-vinculacion',
  templateUrl: 'vinculacion-tercero-vinculacion.component.html'
} )

export class VinculacionTerceroVinculacionComponent implements OnInit {

  columnas: any[];
  carInformacionInicial = true;
  menu: Funcionalidad = new Funcionalidad();
  carTabla = false;
  formulario: FormGroup;
  vinculacion: ListaItem;
  submitted = false;

  /** Listas */
  lisMenusTodos: MenuVisita[] = [];
  lisMenus: SelectItem[] = [];
  lisMenuVinculacion: MenuVisitaVinculacion[] = [];

  constructor( private navServicio: NavService,
               private cuePreguntaService: CuestionarioPreguntaService,
               private cuePreguntaRespuestaServicio: CuestionarioPreguntaRespuestaService,
               private cueServicio: CuestionarioService,
               private router: Router,
               private autServicio: AutenticacionService,
               private conServicio: ConfirmationService,
               private serMenu: MenuVisitaService,
               private serLista: ListaService,
               private route: ActivatedRoute,
               private fb: FormBuilder,
               private serMenuVinculacion: MenuVisitaVinculacionService ) {
  }

  ngOnInit(): void {
    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/vinculacion-tercero' );
        if ( mn ) {
          this.menu = mn;
        }
        this.columnas = [
          { field: 'menuVisita', header: this.navServicio.buscarMensaje( 'VINCULACIONTERCERO.LBL_MENUPADRE' ), sort: false },
          { field: 'orden', header: this.navServicio.buscarMensaje( 'CUESTIONARIOPREGUNTA.LBL_ORDEN' ), sort: false },
          { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: false },
          { field: 'indicadorTodos', header: this.navServicio.buscarMensaje( 'VINCULACIONTERCERO.LBL_TODASOCUP' ), sort: false },
          { field: 'det', header: this.navServicio.buscarMensaje( 'VINCULACIONTERCERO.LBL_SUBMENU' ), sort: false },
        ];
        this.carTabla = true;


        forkJoin( this.serLista.getMasterDetailsByIdItem( 'ListasTiposVinculaciones', params[ 'id' ] ),
          this.serMenu.obtenerPadres() ).subscribe( ( [ vinculacion, menus ] ) => {

          this.vinculacion = vinculacion;
          this.lisMenusTodos = menus;
          this.serMenuVinculacion.listadoPorVinculacionSoloPadres( this.vinculacion.idLista ).subscribe( menuVinculacion => {
            this.lisMenuVinculacion = menuVinculacion;

            this.lisMenusTodos.map( ( s: MenuVisita ) => {
              if ( !this.lisMenuVinculacion.find( x => x.idMenuVisita === s.idMenuVisita ) ) {
                this.lisMenus.push( { label: s.nombre, value: s.idMenuVisita } );
              }
            } );

            this.ordenarMenuVinculacion();
            this.cargarFormulario();
            this.carTabla = false;
            this.carInformacionInicial = false;
          } );

        } );
      }
    } );

  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      idMenuVisitaVinculacion: [ null ],
      idMenuVisita: [ null ],
      idTipoVinculacion: [ this.vinculacion ? this.vinculacion.idLista : null, [ Validators.required ] ],
      orden: [ null ],
      indicadorTodos: [ true, [ Validators.required ] ],
      indicadorHabilitado: [ true, [ Validators.required ] ],
    } );
  }

  ordenarMenuVinculacion() {
    this.lisMenuVinculacion.sort( function( a, b ) {
      if ( a.orden < b.orden ) {
        return -1;
      } else {
        return 1;
      }
    } );
  }


  onSubmit() {
    this.submitted = true;
    this.carTabla = true;
    if ( this.formulario.valid ) {
      const formulario = this.formulario.getRawValue();
      if ( this.lisMenuVinculacion.length > 0 ) {
        let orden = 0;
        this.lisMenuVinculacion.map( ( s: MenuVisitaVinculacion ) => {
          if ( s.orden > orden ) {
            orden = s.orden;
          }
        } );
        formulario.orden = orden + 1;
      } else {
        formulario.orden = 0;
      }
      this.serMenuVinculacion.crearConHijos( formulario ).subscribe( meTitular => {
        this.lisMenuVinculacion = [];
        this.serMenuVinculacion.listadoPorVinculacionSoloPadres( this.vinculacion.idLista ).subscribe( menuTitu => {
          this.lisMenuVinculacion = menuTitu;
          this.ordenarMenuVinculacion();
          this.lisMenus = [];
          this.lisMenusTodos.map( ( s: MenuVisita ) => {
            if ( !this.lisMenuVinculacion.find( x => x.idMenuVisita === s.idMenuVisita ) ) {
              this.lisMenus.push( { label: s.nombre, value: s.idMenuVisita } );
            }
          } );
          this.carTabla = false;
          this.submitted = false;
        } );
      } );

    }
  }


  get f() {
    return this.formulario.controls;
  }

  habilitar( item: MenuVisitaVinculacion ) {

    this.carTabla = true;
    /** Se Actualiza el menu vinculación */
    this.serMenuVinculacion.actualizar( item ).subscribe( menuActualizado => {
      this.lisMenuVinculacion = [];
      this.serMenuVinculacion.listadoPorVinculacionSoloPadres( this.vinculacion.idLista ).subscribe( menuTitu => {
        this.lisMenuVinculacion = menuTitu;
        this.ordenarMenuVinculacion();
        this.carTabla = false;
      } );
    } );
  }


  bajar( item: MenuVisitaVinculacion ) {
    let miIndice = this.lisMenuVinculacion.indexOf( item );
    if ( miIndice < this.lisMenuVinculacion.length - 1 ) {
      this.carTabla = true;
      this.cambiarOrden( miIndice, false );
    }
  }

  subir( item: MenuVisitaVinculacion ) {
    let miIndice = this.lisMenuVinculacion.indexOf( item );
    if ( miIndice > 0 ) {
      this.carTabla = true;
      this.cambiarOrden( miIndice, true );
    }
  }

  cambiarOrden( miIndice: number, subir: boolean ) {
    let nueOrden = this.lisMenuVinculacion[ miIndice ].orden;
    if ( subir ) {
      this.lisMenuVinculacion[ miIndice ].orden = this.lisMenuVinculacion[ miIndice - 1 ].orden;
      this.serMenuVinculacion.actualizar( this.lisMenuVinculacion[ miIndice ] ).subscribe( res => {
        this.lisMenuVinculacion[ miIndice - 1 ].orden = nueOrden;
        this.serMenuVinculacion.actualizar( this.lisMenuVinculacion[ miIndice - 1 ] ).subscribe( resB => {
          this.ordenarMenuVinculacion();
          this.carTabla = false;
        } );
      } );
    } else {
      this.lisMenuVinculacion[ miIndice ].orden = this.lisMenuVinculacion[ miIndice + 1 ].orden;
      this.serMenuVinculacion.actualizar( this.lisMenuVinculacion[ miIndice ] ).subscribe( res => {
        this.lisMenuVinculacion[ miIndice + 1 ].orden = nueOrden;
        this.serMenuVinculacion.actualizar( this.lisMenuVinculacion[ miIndice + 1 ] ).subscribe( resB => {
          this.ordenarMenuVinculacion();
          this.carTabla = false;
        } );
      } );
    }

  }

  configuarOcupacion( item: MenuVisitaVinculacion ) {
    this.router.navigate( [ 'apl/vinculacion-tercero/configurar-ocupacion/' + item.idMenuVisitaVinculacion ] );
  }

  verSubmenu( item: MenuVisitaVinculacion ) {
    let menu: any;
    this.serMenu.obtenerHijos( item.idMenuVisita ).subscribe( regs => {
      menu = regs.children;
      if ( menu !== null && menu.length > 0 ) {
        this.router.navigate( [ 'apl/vinculacion-tercero/configurar-vinculacion/detalle-submenu/' + item.idMenuVisitaVinculacion ] );
      } else {
        this.navServicio.setMesage( 0, {
          severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navServicio.buscarMensaje( 'VINCULACIONTERCERO.MSG_ERRORHIJOS' )
        } );
      }
    } );
  }

  regresar() {
    this.router.navigate( [ 'apl/vinculacion-tercero/' ] );
  }
}
